export enum NavItemsEnum {
  LAB = 'labs',
  STORE = 'store',
  MARKETPLACE = 'marketplace',
  IVEND = 'ivendPay'
}